
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const getProjectsByVisaId = createAsyncThunk("api/visa-project", async (token,id) => {
  try {
    console.log("id......................",id)
    const response = await nodeinstance.get(`/dashboard/visa-stock/getProjectsByVisaId/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const projectsByVisaId = createSlice({
  name: "visa-project",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getProjectsByVisaId.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true
      })
      .addCase(getProjectsByVisaId.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProjectsByVisaId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getProjectsByVisaId };
export default projectsByVisaId.reducer;
